import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty, isNullOrUndefined, isPresent } from 'utils'
import { DocumentItem } from 'features/channel/add/part/DocumentItem'
import Table from 'components/table/Table'
import { setReviewDocumentsFromOldData } from 'features/channel/add/channelAddSlice'

const Document = ({ isEditable }) => {
  const { reviewDocuments, oldReviewDocuments, selectedCategoryDetail } =
    useSelector(state => state.channel.channelAdd)
  const dispatch = useDispatch()
  const [reviewDocumentsSetFromOld, setReviewDocumentsSetFromOld] =
    useState(false)

  useEffect(() => {
    if (
      !reviewDocumentsSetFromOld &&
      isPresent(oldReviewDocuments) &&
      isPresent(reviewDocuments)
    ) {
      setReviewDocumentsSetFromOld(true)
      dispatch(setReviewDocumentsFromOldData())
    }
  }, [dispatch, reviewDocuments, oldReviewDocuments, reviewDocumentsSetFromOld])
  return (
    <Table.Row className="tr_document">
      <th scope="row">
        <div className="inner_tbl">심사서류</div>
      </th>
      <td>
        <div className="inner_tbl">
          <div className="item_tit">
            <strong className="tit_detail">
              해당 카테고리에 필요한 서류를 모두 등록하지 않은 경우 비즈채널
              심사에서 보류될 수 있습니다.
              <br />
              {isNullOrUndefined(selectedCategoryDetail) &&
                '업종 선택해주세요.'}
              {!isEmpty(reviewDocuments) && (
                <>
                  서류첨부시&nbsp;
                  <strong>
                    불필요한 개인정보(주민등록번호, 카드번호, 계좌번호등)가
                    포함되지 않도록 반드시 마스킹(가림처리) 후 첨부
                  </strong>
                  해야 합니다.
                  <br />
                  개인 정보가 포함된 심사서류는 개인 정보 보호를 위해 관리자가
                  임의로 삭제할 수 있습니다.
                </>
              )}
            </strong>
            {!isEmpty(reviewDocuments) && (
              <div className="group_registlist">
                <strong className="tit_regist">
                  파일당 용량 최대 <em className="fc_warn2">10MB</em>
                </strong>
                <ul className="list_document">
                  {reviewDocuments.map(document => (
                    <DocumentItem
                      key={document.id}
                      isEditable={isEditable}
                      document={document}
                    />
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </td>
    </Table.Row>
  )
}

export default Document
Document.propTypes = {
  isEditable: PropTypes.bool,
}
